import { useEffect, useState, useRef } from "react";

const STATS = [
  { label: "Successful Projects", value: 1730, suffix: "+" },
  { label: "Million Sq. Ft. Delivered", value: 2.5, suffix: "M" },
  { label: "Client Retention", value: 98, suffix: "%" },
  { label: "Professionals", value: 150, suffix: "+" },
];

export default function StatsSection({
  isCompact = false,
}: {
  isCompact?: boolean;
}) {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.2 },
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className={`${isCompact ? "py-4 bg-transparent" : "py-24 bg-white border-y border-gray-100"}`}
    >
      <div
        className={`${isCompact ? "max-w-full px-0" : "max-w-[1400px] mx-auto px-6"}`}
      >
        <div
          className={`grid ${isCompact ? "grid-cols-2 gap-4" : "grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12"}`}
        >
          {STATS.map((stat, i) => (
            <div
              key={i}
              className={`group ${isCompact ? "text-left p-4 bg-gray-50 border border-gray-200 rounded-xs" : "text-center"}`}
            >
              <div
                className={`${isCompact ? "text-2xl sm:text-3xl font-extrabold" : "stat-number mb-4"} text-[#002b5c] transition-colors font-heading`}
              >
                {visible ? <Counter end={stat.value} /> : "0"}
                {stat.suffix}
              </div>
              {!isCompact && (
                <div className="h-1 w-12 bg-[#ffcc29] mx-auto mb-6 group-hover:w-20 transition-all" />
              )}
              <div
                className={`${isCompact ? "text-[11px] text-gray-600 mt-1" : "text-gray-500 text-sm"} font-heading font-bold tracking-widest uppercase`}
              >
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Counter({ end }: { end: number }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const duration = 2000;
    const increment = end / (duration / 16);

    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start * 10) / 10);
      }
    }, 16);

    return () => clearInterval(timer);
  }, [end]);

  return <>{count}</>;
}
